import { Component } from '@theme/component';

class MediaGroupComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (this.dataset.autoLayout !== 'true') return;

    this.boundLayout = this.layout.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.boundLayout);
    } else {
      this.layout();
    }

    window.addEventListener('resize', this.boundLayout);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.boundLayout) {
      document.removeEventListener('DOMContentLoaded', this.boundLayout);
      window.removeEventListener('resize', this.boundLayout);
    }
  }

  layout() {
    const isMobile = window.innerWidth <= 749;
    const rawItems = Array.from(this.querySelectorAll(':scope > .media-group-item'));
    const totalCols = parseInt(getComputedStyle(this).getPropertyValue('--column-span').trim()) || 3;
    const orderProp = isMobile ? '--mobile-order' : '--desktop-order';

    const unordered = [];
    const ordered = [];
    rawItems.forEach((item, i) => {
      const order = parseInt(getComputedStyle(item).getPropertyValue(orderProp).trim()) || 0;
      if (order > 0) {
        ordered.push({ item, order, domIndex: i });
      } else {
        unordered.push(item);
      }
    });

    ordered.sort((a, b) => a.order !== b.order ? a.order - b.order : a.domIndex - b.domIndex);

    const items = unordered.slice();
    ordered.forEach((entry) => {
      const idx = Math.min(entry.order - 1, items.length);
      items.splice(idx, 0, entry.item);
    });

    const colEnds = new Array(totalCols).fill(0);
    const visualRows = [];
    let currentRowItems = [];
    let currentColCount = 0;

    items.forEach((item) => {
      const cs = getComputedStyle(item);
      const rowSpan = parseInt(cs.getPropertyValue(isMobile ? '--mobile-media-column' : '--desktop-media-column').trim()) || 1;
      const colSpan = parseInt(cs.getPropertyValue(isMobile ? '--mobile-media-row' : '--desktop-media-row').trim()) || 1;

      if (currentColCount + colSpan > totalCols) {
        visualRows.push(currentRowItems);
        currentRowItems = [];
        currentColCount = 0;
      }

      currentRowItems.push({ item, rowSpan, colSpan });
      currentColCount += colSpan;
    });

    if (currentRowItems.length > 0) visualRows.push(currentRowItems);

    visualRows.forEach((rowItems) => {
      let currentCol = 0;
      rowItems.forEach(({ item, rowSpan, colSpan }) => {
        let maxEnd = 0;
        for (let i = currentCol; i < currentCol + colSpan; i++) {
          if (colEnds[i] > maxEnd) maxEnd = colEnds[i];
        }
        const rowStart = maxEnd + 1;

        item.style.gridRow = `${rowStart} / span ${rowSpan}`;
        item.style.gridColumn = `${currentCol + 1} / span ${colSpan}`;

        for (let j = currentCol; j < currentCol + colSpan; j++) {
          colEnds[j] = rowStart + rowSpan - 1;
        }
        currentCol += colSpan;
      });
    });
  }
}

customElements.define('media-group-component', MediaGroupComponent);
